import { useState } from 'react';

import { MAX_CHAR } from '../config';

function useCharOverAndAvailCount (initialCharOver = 0, initialCharCount = MAX_CHAR) {

	const [ charOver, setCharOver ] = useState(initialCharOver);
	const [ availCharCount, setAvailCharCount ] = useState(initialCharCount);

	const setCountWhenInputBlank = () => {

		setAvailCharCount(MAX_CHAR);
		setCharOver(0);

	};

	const setCountWhenInputOverMax = (input) => {

		setCharOver(input.length - MAX_CHAR);

	};

	const setCountWhenInputLessThanMax = (availCount) => {

		setCharOver(0);
		setAvailCharCount(availCount);

	};

	const resetCharOverAndAvail = () => {

		setCharOver(0);
		setAvailCharCount(MAX_CHAR);

	};

	return {
		availCharCount,
		charOver,
		setCountWhenInputBlank,
		setCountWhenInputOverMax,
		setCountWhenInputLessThanMax,
		resetCharOverAndAvail
	};

}

export default useCharOverAndAvailCount;
